<template>
  <v-app
    id="PostFiltrations"
    post_type="charter"
    per_page="15"
    Url="https://capsource.io"
  >
    <div id="app">
      <div id="filter-nav">
        <div class="filter-home">
          <component
            :is="ComponentFilter"
            :args="args"
            :loaded_filters="loaded_filters"
            @UpdateFilter="UpdateFilter($event)"
            @ResetSelection="ResetSelection($event)"
            id="filters"
            v-if="loaded_filters"
          />
          <div v-if="isLoading" class="text-center pa-15 ma-2">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <component
            :is="ComponentCard"
            v-for="entry in posts.data.entries"
            :key="entry.id"
            :data="entry"
            id="cards"
          />
          <div
            id="pagination"
            class="text-right pa-15 ma-2"
            v-if="pagination.pages > 1"
          >
            <v-progress-circular
              v-if="PaginationLoader"
              class="mt-3"
              :size="20"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-pagination
              class="float-right"
              v-model="pagination.page"
              :length="pagination.pages"
              :total-visible="7"
              @input="paginate"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import merge from "deepmerge";
import _ from "lodash";
export default {
  name: "Home",
  data: function() {
    return {
      // currentUrl:
      //   location.protocol +
      //   "//" +
      //   location.hostname +
      //   (location.port ? ":" + location.port : ""),
      currentUrl: "",
      isLoading: false,
      posts: {
        status: null,
        data: {
          entries: {},
          filters: {},
        },
      },
      args: {
        post_type: "",
        posts_per_page: 10,
      },
      ComponentFilter: "",
      ComponentCard: "",
      Filters: {},
      pagination: {
        page: 1,
        pages: 0,
      },
      offset: 0,
      PaginationLoader: false,
      loaded_filters: {},
    };
  },
  methods: {
    paginate(page) {
      this.PaginationLoader = true;
      if (page > 1) {
        this.Filters.offset = this.args.posts_per_page * (page - 1);
      } else {
        _.unset(this.Filters, "offset");
      }
      this.$vuetify.goTo("#pagination");
      this.load_posts();
    },
    UpdateFilter(filters) {
      this.offset = 0;
      this.Filters = merge(this.args, filters);
      this.load_posts();
    },
    ResetSelection() {
      this.args.paged = 0;
      this.args.offset = 0;
    },
    load_filters() {
      const baseURL = this.currentUrl + "/wp-json/rest/v2/pts/filters";
      const this_ = this;
      axios.defaults.params = { post_type: this_.args.post_type };
      axios
        .get(baseURL)
        .then(function(response) {
          this_.loaded_filters = response.data;
        })
        .catch(function(error) {
          console.error(error.response);
        })
        .then(function() {});
    },
    load_posts() {
      const baseURL = this.currentUrl + "/wp-json/rest/v2/pts/";
      const this_ = this;
      this_.isLoading = true;
      axios.defaults.params = this_.Filters;
      axios
        .get(baseURL)
        .then(function(response) {
          this_.posts = response;
          this_.pagination.pages = this_.posts.data.pages;
          this_.isLoading = false;
          this_.PaginationLoader = false;
          this_.$vuetify.goTo("#filters");
        })
        .catch(function(error) {
          console.error(error.response);
        })
        .then(function() {});
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.currentUrl = CapSourceListingCurrentUrl;
    // eslint-disable-next-line no-undef
    this.args.post_type = CapSourceListingPostType;
    // eslint-disable-next-line no-undef
    this.args.posts_per_page = CapSourceListingPostsPerPage;

    this.Filters = this.args;

    // Load Posts
    this.load_filters();

    // Load Posts
    this.load_posts();

    // Loader Component
    this.load_component()
      .then(() => {
        this.ComponentCard = () => this.load_component();
      })
      .catch(() => {
        this.ComponentCard = () => import("@/views/Card");
      });

    // Loader Component
    this.load_filter()
      .then(() => {
        this.ComponentFilter = () => this.load_filter();
      })
      .catch(() => {
        this.ComponentFilter = () => import("@/views/Filter");
      });
  },
  computed: {
    load_component() {
      if (!this.args.post_type) {
        return null;
      }
      return () => import(`@/views/${this.args.post_type}/Card`);
    },
    load_filter() {
      if (!this.args.post_type) {
        return null;
      }
      return () => import(`@/views/${this.args.post_type}/Filter`);
    },
  },
};
</script>
